import React from 'react';
import { ClassificationBadgeDisplay } from '../../../utils/classificationBadgeDisplay';

interface ClassificationBadgeProps {
  badge: ClassificationBadgeDisplay;
  compact?: boolean;
  className?: string;
}

export const ClassificationBadge: React.FC<ClassificationBadgeProps> = ({
  badge,
  compact = false,
  className = '',
}) => {
  const title = badge.appliedByBot
    ? `${badge.fieldTitle}: ${badge.label}`
    : `${badge.fieldTitle}: ${badge.label}`;

  return (
    <span
      className={`inline-flex items-center flex-shrink-0 rounded-full font-semibold text-white ${
        compact ? 'text-[10px] px-1.5 py-0.5' : 'text-[11px] px-2 py-0.5'
      } ${className}`}
      style={{ backgroundColor: badge.color }}
      title={title}
    >
      {badge.label}
    </span>
  );
};
